interface VersionProps {
  className?: string;
  variant?: 'footer' | 'header' | 'tooltip';
}

export function Version({ className = '', variant = 'footer' }: VersionProps) {
  const version = __APP_VERSION__;
  const buildDate = __BUILD_DATE__;

  const baseClasses = 'text-gray-500 text-sm';
  
  const variantClasses = {
    footer: 'text-xs',
    header: 'text-xs opacity-75',
    tooltip: 'text-xs'
  };

  const formattedDate = new Date(buildDate).toLocaleDateString();
  const tooltipText = `Commit: ${version}\nBuild Date: ${formattedDate}`;

  if (variant === 'footer') {
    return (
      <div 
        className={`${baseClasses} ${variantClasses[variant]} ${className}`}
        title={tooltipText}
      >
        <div>{version}</div>
        <div className="text-gray-400">{formattedDate}</div>
      </div>
    );
  }

  return (
    <span 
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      title={tooltipText}
    >
      {version}
    </span>
  );
} 